import { CartItem, CartPriceItem } from './CartResult';
import { itemQuantity } from './utils';

export class SkuList {
    public collection: CartItem[] = [];
    public package?: CartItem['package'];
    public thumbnail?: string;
    public price?: CartPriceItem;
    public item!: CartItem;

    public setItem(item: CartItem) {
        if (!this.item) {
            this.item = item;
        }
    }

    public static fromItems(items: CartItem[]) {
        const list = new SkuList();
        items.forEach((item) => {
            if (item.model_id && this.isApparelOrFactorySku(item)) {
                list.add(item, false);
            }
        });

        return list;
    }

    public count(): number {
        return this.collection?.length || 0;
    }

    public add(item: CartItem, merge = true) {
        let found = false;
        if (merge) {
            this.collection = this.collection.map((cartItem) => {
                if (cartItem.sku_id === item.sku_id && cartItem.image_id === item.image_id) {
                    found = true;
                    return {
                        ...cartItem,
                        quantity: itemQuantity(cartItem.quantity) + itemQuantity(item.quantity),
                    };
                }

                return cartItem;
            });
        }

        if (!found) {
            this.collection = [...this.collection, { ...item }];
        }

        return this;
    }

    public attachPackage(value: any) {
        if (!this.package) {
            this.package = value;
        }
    }

    public attachThumbnail(thumbnail: string) {
        if (!this.thumbnail) {
            this.thumbnail = thumbnail;
        }
    }

    public attachPrice(price: CartPriceItem) {
        if (!this.price) {
            this.price = price;
        }
    }

    public getPackageQuantity() {
        return this.collection[0].quantity;
    }

    static isApparelOrFactorySku(item$): boolean {
        return (
            item$.model_type === 'Wooter\\WApparelSKU' ||
            item$.model_type === 'Wooter\\WApparelSKUFactory' ||
            item$.model_type === 'sku' ||
            item$.model_type === 'factorySku'
        );
    }
}
